import Vue from 'vue';
import moment from 'moment';

let date = Vue.filter('date', function (value, format = 'YYYY-MM-DD') {
    if (value) {
        return moment(value).format(format);
    } else {
        return '';
    }
});

let dateInput = Vue.filter('dateInput', {
    read: function (value) {
        return moment(value).format('DD.MM.YYYY');
    },
    write: function (value, oldValue) {
        return moment(value).toDate();
    }
});

export default { date, dateInput };